<template>
  <div class="Toolbar">
    <Keywords/>
    <ToolMenus/>
  </div>
</template>

<script>
import Keywords from '@/components/Keywords'
import ToolMenus from '@/components/ToolMenus'

export default {
  name: 'Toolbar',
  components: { Keywords, ToolMenus },
};
</script>

<style scoped lang="scss">
.Toolbar {
  @include cf;
  background: $gray-lighter;
  width: 100%;
}
</style>
